import * as React from "react";
import { SVGProps } from "react";
export const CloudArrowUpFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.43801 16.667C4.16001 16.667 3.07301 16.219 2.17701 15.323C1.28101 14.427 0.833008 13.34 0.833008 12.062C0.833008 10.9793 1.15601 10.0247 1.80201 9.19801C2.44801 8.37134 3.29867 7.83301 4.35401 7.58301C4.71534 6.31967 5.41667 5.29534 6.45801 4.51001C7.50001 3.72534 8.68067 3.33301 10 3.33301C11.5973 3.33301 12.9757 3.89201 14.135 5.01001C15.295 6.12867 15.875 7.48634 15.875 9.08301C16.8197 9.19434 17.6043 9.61467 18.229 10.344C18.8543 11.0733 19.167 11.917 19.167 12.875C19.167 13.917 18.7953 14.8093 18.052 15.552C17.3093 16.2953 16.417 16.667 15.375 16.667H10.875V10.75L11.562 11.438C11.7287 11.6047 11.9303 11.688 12.167 11.688C12.403 11.688 12.6043 11.6047 12.771 11.438C12.9377 11.2713 13.021 11.0697 13.021 10.833C13.021 10.597 12.9377 10.3957 12.771 10.229L10.625 8.08301C10.4583 7.91634 10.25 7.83301 10 7.83301C9.75001 7.83301 9.54167 7.91634 9.37501 8.08301L7.22901 10.229C7.06234 10.3957 6.97901 10.597 6.97901 10.833C6.97901 11.0697 7.06234 11.2713 7.22901 11.438C7.39567 11.6047 7.59701 11.688 7.83301 11.688C8.06967 11.688 8.27134 11.6047 8.43801 11.438L9.12501 10.75V16.667H5.43801Z"
            fill="currentColor"
        />
    </svg>
);
CloudArrowUpFillIcon.displayName = "CloudArrowUpFillIcon";
